import { useQuery } from '@tanstack/react-query';

import { appDataApi } from '../appData.api';

export const useQuerySurgeonsRegions = () =>
  useQuery({
    queryKey: ['surgeons', 'regions'],
    queryFn: appDataApi.getSurgeonsRegions,
  });
